<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import {validatePassword, validateStringMatch} from "../../services/ValidatorService";

export default Vue.extend({
    computed: {
        ...mapState({
            password: state => state.account.password
        }),
        passwordClasses() {
            return {
                'account-password__input--error': this.$v.password.password.$dirty && this.$v.password.password.$error,
                'account-password__input--success': this.$v.password.password.$dirty && !this.$v.password.password.$error
            }
        },
        newPasswordClasses() {
            return {
                'account-password__input--error': this.$v.password.newPassword.$dirty && this.$v.password.newPassword.$error,
                'account-password__input--success': this.$v.password.newPassword.$dirty && !this.$v.password.newPassword.$error
            }
        },
        retypePasswordClasses() {
            return {
                'account-password__input--error': this.$v.password.retypePassword.$dirty && this.$v.password.retypePassword.$error,
                'account-password__input--success': this.$v.password.retypePassword.$dirty && !this.$v.password.retypePassword.$error
            }
        },
    },
    methods: {
        ...mapActions({
            editPassword: 'account/editPassword',
            resetPassword: 'account/resetPassword',
            updatePassword: 'account/updatePassword'
        }),
        edit(obj) {
            this.$v.$touch();
            this.editPassword(obj);
        },
        update() {
            this.$v.$reset();
            this.updatePassword();
        },
        reset() {
            this.$v.$reset();
            this.resetPassword();
        }
    },
    validations() {
        return {
            password: {
                password: {
                    validatePassword: (password) => {
                        return validatePassword(password).valid;
                    }
                },
                newPassword: {
                    validatePassword: (password) => {
                        return validatePassword(password).valid;
                    }
                },
                retypePassword: {
                    validateStringMatch: (retypePassword, state) => {
                        return validateStringMatch(retypePassword, state.newPassword).valid;
                    }
                }
            }
        }
    },
});
</script>

<template>
    <div class="account-password">
        <div class="account-password__heading">
            <div class="account-password__header">
                {{ $t('account.password.heading.header') }}
            </div>
        </div>
        <div class="account-password__passwords">
            <div class="account-password__password">
                <label for="account-password__password">{{ $t('account.password.password') }}:</label>
                <input id="account-password__password"
                       :class="passwordClasses"
                       :placeholder="$t('account.password.placeholder.password')"
                       :value="password.password"
                       class="account-password__input"
                       type="password"
                       @input="edit({password: $event.target.value})">
                <transition name="fade" mode="out-in">
                    <div v-if="$v.password.password.$dirty && $v.password.password.$error" class="account-password__error">*{{ $t('account.password.validator.password') }}</div>
                </transition>
            </div>
            <div class="account-password__password">
                <label for="account-password__new-password">{{ $t('account.password.newPassword') }}:</label>
                <input id="account-password__new-password"
                       :class="newPasswordClasses"
                       :placeholder="$t('account.password.placeholder.password')"
                       :value="password.newPassword"
                       class="account-password__input"
                       type="password"
                       @input="edit({newPassword: $event.target.value})">
                <transition name="fade" mode="out-in">
                    <div v-if="$v.password.newPassword.$dirty && $v.password.newPassword.$error" class="account-password__error">*{{ $t('account.password.validator.password') }}</div>
                </transition>
            </div>
            <div class="account-password__password">
                <label for="account-password__re-password">{{ $t('account.password.rePassword') }}:</label>
                <input id="account-password__re-password"
                       :class="retypePasswordClasses"
                       :placeholder="$t('account.password.placeholder.password')"
                       :value="password.retypePassword"
                       class="account-password__input"
                       type="password"
                       @input="edit({retypePassword: $event.target.value})">
                <transition name="fade" mode="out-in">
                    <div v-if="$v.password.retypePassword.$error" class="account-password__error">*{{ $t('account.password.validator.mismatch') }}</div>
                </transition>
            </div>
        </div>
        <div class="account-password__buttons">
            <div class="account-password__button-group">
                <button :disabled="!$v.$dirty || $v.$error" class="account-password__btn account-password__btn-update" @click="update()">
                    {{ $t('account.password.buttons.update') }}
                </button>
                <button :disabled="!$v.$dirty" class="account-password__btn account-password__btn-reset" @click="reset()">
                    {{ $t('account.password.buttons.reset') }}
                </button>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AccountPassword/AccountPassword.vue